import core from "@/helpers/client";
const parameterParameter = {
  async headParameterAsync(applicationId, serviceId, params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services/${serviceId}/parameters?no-cache=1`,
      params
    );
    return result;
  },
  async getParametersAsync(applicationId, serviceId, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services/${serviceId}/parameters?no-cache=1`,
      params
    );
    return result;
  },
  async getParameterAsync(applicationId, serviceId, id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services/${serviceId}/parameters/${id}?no-cache=1`
    );
    return result;
  },
  async createParameterAsync(applicationId, serviceId, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services/${serviceId}/parameters`,
      model
    );
    return result;
  },
  async updateParameterAsync(applicationId, serviceId, id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services/${serviceId}/parameters/${id}`,
      model
    );
    return result;
  },
  async deleteParameterAsync(applicationId, serviceId, id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/services/${serviceId}/parameters/${id}`
    );
    return result;
  },
};
export default parameterParameter;
